import * as React from "react"

export default function NotificationSolidIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.332 11.332h1.333v1.333H1.332v-1.333h1.333V6.665a5.333 5.333 0 0110.667 0v4.667zm-7.333 2.667h4v1.333h-4v-1.333z"
        fill={props.fill}
      />
    </svg>
  )
}
